import { MissingCostsEnum } from 'api';
import { type I18nTranslateFunction, useTranslation } from 'i18n';
import { Alert } from 'ui';

type Props = {
  missingCosts?: MissingCostsEnum[];
};

const getDisplayedMissingCost = (t: I18nTranslateFunction<string>, missingCost: MissingCostsEnum) => {
  switch (missingCost) {
    case MissingCostsEnum.DESTINATION_INTERMODAL_COST:
      return t('profitabilityCalculator.missingCosts.options.destinationIntermodalCost');
    case MissingCostsEnum.DESTINATION_TERMINAL_HANDLING_CHARGE:
      return t('profitabilityCalculator.missingCosts.options.destinationTerminalHandlingCharge');
    case MissingCostsEnum.LOCAL_DESTINATION_COST:
      return t('profitabilityCalculator.missingCosts.options.localDestinationCost');
    case MissingCostsEnum.LOCAL_ORIGIN_COST:
      return t('profitabilityCalculator.missingCosts.options.localOriginCost');
    case MissingCostsEnum.OCEAN_FREIGHT_COST:
      return t('profitabilityCalculator.missingCosts.options.oceanFreightCost');
    case MissingCostsEnum.ORIGIN_DOC_FEE:
      return t('profitabilityCalculator.missingCosts.options.originDocFee');
    case MissingCostsEnum.ORIGIN_INTERMODAL_COST:
      return t('profitabilityCalculator.missingCosts.options.originIntermodalCost');
    case MissingCostsEnum.ORIGIN_TERMINAL_HANDLING_CHARGE:
      return t('profitabilityCalculator.missingCosts.options.originTerminalHandlingCharge');
  }
};

export const MissingCostsAlert = ({ missingCosts }: Props) => {
  const { t } = useTranslation('orders');

  if ((missingCosts?.length || 0) > 0) {
    return (
      <Alert severity="warning">
        {t('profitabilityCalculator.missingCosts.message', {
          values: {
            missingCosts: missingCosts?.map((missingCost) => getDisplayedMissingCost(t, missingCost)).join(', '),
          },
        })}
      </Alert>
    );
  }
  return null;
};
